export const PREVIEW_VARS = {
  person_email: 'charles@dickens.org',
  person_first_name: 'Charles',
  person_last_name: 'Dickens',
  person_display_name: 'Charles Dickens',
  person_employee_id: '1001234',
  person_account_name: 'charles_dickens',
  person_position: 'Copywriter',
  person_area: 'London',
  person_department: 'Marketing',
  person_location: 'Europe',
  person_phone_number: '+447911123456',
  manager_display_name: 'Jane Austen',
  manager_first_name: 'Jane',
  manager_last_name: 'Austen',
  manager_employee_id: '201234',
  manager_account_name: 'jane_austen',
  manager_position: 'UX Lead',
  manager_area: 'London',
  manager_department: 'Marketing',
  manager_location: 'Europe',
  manager_phone_number: '+446811123456'
}
